import React from 'react'
import { Button } from '/src/components/common'

export const chunkArray = (arr, chunkSize) => {
  const results = []

  for (var i=0, len=arr.length; i < len; i += chunkSize) {
    results.push(arr.slice(i, i + chunkSize))
  }

  return results
}

export const Pagination = ({ currentPage, totalItems, pageSize, setPage }) => {
  const items = chunkArray(totalItems, pageSize)

  const handleClick = (value) => {
    setPage(value)
  }

  return (
    <ul className="pagination">
      {items.map((item, index) => {
        const displayIndex = index + 1
        const itemClasses = ['pagination-item']

        if (index === currentPage) {
          itemClasses.push('active')
        }

        return (
          <li key={index} className={itemClasses.join(' ')}>
            <Button onClick={() => handleClick(index)}>
              {displayIndex}
            </Button>
          </li>
        )
      })}
    </ul>
  )
}

export default Pagination